import React from 'react';
import Modal from 'react-modal';
import { T } from 'shared/helper/translate';
var ModalConfirm = function ModalConfirm(_ref) {
  var _ref$appElement = _ref.appElement,
    appElement = _ref$appElement === void 0 ? 'div.admin-app' : _ref$appElement,
    children = _ref.children,
    close = _ref.close,
    _ref$noText = _ref.noText,
    noText = _ref$noText === void 0 ? 'no' : _ref$noText,
    show = _ref.show,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'are you sure' : _ref$title,
    _ref$yesAction = _ref.yesAction,
    yesAction = _ref$yesAction === void 0 ? function () {} : _ref$yesAction,
    _ref$yesText = _ref.yesText,
    yesText = _ref$yesText === void 0 ? 'yes' : _ref$yesText,
    _ref$noAction = _ref.noAction,
    noAction = _ref$noAction === void 0 ? function () {} : _ref$noAction,
    _ref$hideNo = _ref.hideNo,
    hideNo = _ref$hideNo === void 0 ? false : _ref$hideNo;
  var handleYes = function handleYes() {
    yesAction();
    close();
  };
  var handleNo = function handleNo() {
    noAction();
    close();
  };
  var element = document.querySelector(appElement) || document.querySelector('#researcher-app');
  return show ? /*#__PURE__*/React.createElement(Modal, {
    appElement: element,
    className: "react-modal",
    isOpen: show,
    overlayClassName: "react-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: close,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary btn-squared me-3",
    type: "button",
    onClick: handleYes
  }, /*#__PURE__*/React.createElement(T, {
    source: yesText
  })), hideNo ? null : /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary btn-squared",
    type: "button",
    onClick: handleNo
  }, /*#__PURE__*/React.createElement(T, {
    source: noText
  })))) : null;
};
export default ModalConfirm;